/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTournamentParticipantStreamBody
 */
export interface CreateTournamentParticipantStreamBody {
    /**
     * Which connected channel to surface as this participant's POV.
     * @type {string}
     * @memberof CreateTournamentParticipantStreamBody
     */
    platform: CreateTournamentParticipantStreamBodyPlatformEnum;
}


/**
 * @export
 */
export const CreateTournamentParticipantStreamBodyPlatformEnum = {
    TWITCH: 'TWITCH',
    KICK: 'KICK',
    YOUTUBE: 'YOUTUBE'
} as const;
export type CreateTournamentParticipantStreamBodyPlatformEnum = typeof CreateTournamentParticipantStreamBodyPlatformEnum[keyof typeof CreateTournamentParticipantStreamBodyPlatformEnum];


/**
 * Check if a given object implements the CreateTournamentParticipantStreamBody interface.
 */
export function instanceOfCreateTournamentParticipantStreamBody(value: object): value is CreateTournamentParticipantStreamBody {
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function CreateTournamentParticipantStreamBodyFromJSON(json: any): CreateTournamentParticipantStreamBody {
    return CreateTournamentParticipantStreamBodyFromJSONTyped(json, false);
}

export function CreateTournamentParticipantStreamBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTournamentParticipantStreamBody {
    if (json == null) {
        return json;
    }
    return {
        
        'platform': json['platform'],
    };
}

export function CreateTournamentParticipantStreamBodyToJSON(json: any): CreateTournamentParticipantStreamBody {
    return CreateTournamentParticipantStreamBodyToJSONTyped(json, false);
}

export function CreateTournamentParticipantStreamBodyToJSONTyped(value?: CreateTournamentParticipantStreamBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['platform'],
    };
}

